export default __webpack_public_path__ + "static/media/appinfo-placeholder.34af1754.svg";